export default __webpack_public_path__ + "static/media/story_img_1.178d8556.jpeg";